import React from "react";
import { useParams } from "react-router-dom";
import { apiCallPost, initials, niceDateTime, yearFromNow } from "../util/util";
import "../Prescription.css";
import QRCode from "react-qr-code";
import { Button, H4, NonIdealState, Spinner, Tag } from "@blueprintjs/core";
import _ from "lodash";
import cogoToast from "cogo-toast";

function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}

class GlassRxLowerOrder extends React.Component {
  state = { isLoading: true, isFailure: false };
  componentDidMount() {
    let ss = this.props.params.visitId;
    if (ss) {
      this.getSubmission(ss);
    } else {
      this.setState({ isLoading: false, isInvalid: true });
    }
  }
  getSubmission = async (ss) => {
    try {
      let res = await apiCallPost("/print/clinical", {
        visitId: ss,
      });
      try {
        let res2 = await apiCallPost("/print/site_info", {
          site: res.landing.todayVisit.branch,
        });
        this.setState({ site_info: res2, clinical: res, isLoading: false });
      } catch (err) {
        cogoToast.error("Failed to load site data.");
        this.setState({ isLoading: false, isFailure: true });
      }
    } catch (err) {
      cogoToast.error("Failed to load clinical data.");
      this.setState({ isLoading: false, isFailure: true });
    }
  };
  renderHeader = () => {
    return (
      <div className="pres-font__x__small">
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            /*   backgroundColor: "red", */
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                marginRight: "5px",
                marginBottom: "5px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                alt="Client Logo"
                src={this.state.site_info.logoUrl}
                height="85px"
                width="auto"
                className="img_block"
              />
              <b
                style={{
                  fontSize: "9pt",
                  marginTop: "3px",
                  maxWidth: "100px",
                  textAlign: "center",
                }}
              >
                {this.state.site_info.hospital_name}
              </b>
            </div>
            <div>
              <b> {this.state.site_info.hospital_contact[0]}</b> <br />
              {this.state.site_info.hospital_contact[1]} <br />
              {this.state.site_info.hospital_contact[2]} <br />
              {this.state.site_info.hospital_contact[3]} <br />
              {this.state.site_info.ClinicPh} <br />
              {this.state.site_info.email} <br />
              Eye Bank: {this.state.site_info.EyeBankPh} <br />
              Insurance: {this.state.site_info.InsurancePh}
            </div>
          </div>{" "}
          <div
            style={{
              /*  backgroundColor: "green", */
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "flex-start",
              textAlign: "right",
              marginRight: "10px",
            }}
          >
            <div style={{ maxWidth: "50vw" }}>
              <b>{this.state.clinical.landing.name} </b>
              {yearFromNow(this.state.clinical.landing.dob)}
              {" / "}
              {this.state.clinical.landing.sex} <br />
              <Tag minimal className="pres-font__x__small">
                {" "}
                PID: <b>{this.state.clinical.landing.sysPid}</b>
              </Tag>
              <br />
              {this.state.clinical.landing.phone} <br />
              {this.state.clinical.landing.address} <br />
              <hr />{" "}
              <Tag minimal className="pres-font__x__small">
                {" "}
                <b>
                  Consultant: {this.state.clinical.landing.todayVisit.doctor}
                </b>
              </Tag>{" "}
              <br />
              Optometrist:{" "}
              {this.state.clinical.landing.todayVisit.vision.visionDoneBy}
              <br />
              {niceDateTime(
                this.state.clinical.landing.todayVisit.appointmentTime
              )}
            </div>
            <div
              style={{
                /*  backgroundColor: "yellow", */
                marginLeft: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <QRCode
                size={80}
                value={`https://print.newchart.care/glass/${this.props.params.visitId}`}
                level="H"
              />
              <div
                style={{
                  fontSize: "x-small",
                  wordBreak: "break-all",
                  /*          backgroundColor: "blue", */
                  maxWidth: "100px",
                  textAlign: "center",
                }}
              >
                <code> {this.state.clinical.landing.todayVisit._id}</code>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            width: "99vw",
            textAlign: "center",
            justifyContent: "center",
          }}
        >
          <H4>Refraction Advice</H4>
        </div>
      </div>
    );
  };
  /** History */

  /**Symptoms End */
  /** Vision */
  renderVisionSection = () => {
    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          marginBottom: "10px",

          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <>{this.renderVerticalText("VISION")}</>
        <div
          style={{
            marginRight: "10px",

            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {this.renderVisionTable()}
        </div>{" "}
      </div>
    );
  };
  computeBestVision = (v) => {
    let final = [null, null];
    if (v.has_uncorrected) final = ["Uncorrected", v.uncorrected];
    if (v.has_pgp) final = ["PGP", v.pgp];
    if (v.has_corrected_dry) final = ["Dry", v.corrected_dry];
    if (v.has_corrected_dilated) final = ["Dilated", v.corrected_dilated];
    if (v.has_corrected_pmt) final = ["PMT", v.corrected_pmt];
    if (v.has_corrected_rx) final = ["Rx", v.corrected_rx];
    return final;
  };
  renderVisionTable = () => {
    let which = this.computeBestVision(
      this.state.clinical.landing.todayVisit.vision
    );
    let visionRows = [which[1]];
    let visionNice = [which[0]];

    /** IF Condition */
    return (
      <table
        style={{ textAlign: "center" }}
        className="bp4-html-table bp4-html-table-condensed bp4-html-table-bordered bp4-html-table-striped
    "
      >
        <thead>
          <tr style={{ textAlign: "center" }}>
            <th>{visionNice[0]}</th>{" "}
            <th style={{ borderLeft: "solid 1px #5F6B7C" }}>Distance</th>
            <th>Pinhole</th>
            <th>Near</th>
            <th style={{ borderLeft: "solid 1px #5F6B7C" }}>Sph</th>
            <th>Cyl</th>
            <th>Axis</th>
            <th>Add</th>
          </tr>
          {/*  <tr>
            <th rowSpan={2}> </th>
            <th colSpan={7}>Right Eye</th>
            <th colSpan={7} style={{ borderLeft: "solid 1px #5F6B7C" }}>
              Left Eye
            </th>
          </tr>
          <tr>
            <th>Distance</th>
            <th>Pinhole</th>
            <th>Near</th>
            <th>Sph</th>
            <th>Cyl</th>
            <th>Axis</th>
            <th>Add</th>
          </tr>
          <tr>
            <th style={{ borderLeft: "solid 1px #5F6B7C" }}>Distance</th>
            <th>Pinhole</th>
            <th>Near</th>
            <th>Sph</th>
            <th>Cyl</th>
            <th>Axis</th>
            <th>Add</th>
          </tr> */}
        </thead>
        <tbody>{this.renderVisionRows(visionRows, visionNice)}</tbody>
      </table>
    );
  };
  renderVisionRows = (visionRows, visionNice) => {
    return visionRows.map((each, index) => {
      return (
        <>
          <tr style={{ textAlign: "center" }}>
            <td>Right Eye</td>
            <td style={{ borderLeft: "solid 1px #5F6B7C" }}>
              {each.re.v_dist === "---" ? "" : each.re.v_dist}
            </td>
            <td>{each.re.v_ph === "---" ? "" : each.re.v_ph}</td>
            <td>{each.re.v_near === "---" ? "" : each.re.v_near}</td>
            <td style={{ borderLeft: "solid 1px #5F6B7C" }}>
              {each.re.sph === "---" ? "" : this.renderPlusMinus(each.re.sph)}
            </td>
            <td>
              {each.re.cyl === "---" ? "" : this.renderPlusMinus(each.re.cyl)}
            </td>
            <td>
              {each.re.axis === "---" ? "" : this.renderAxis(each.re.axis)}
            </td>
            <td>
              {each.re.add === "---" ? "" : this.renderPlusMinus(each.re.add)}
            </td>
          </tr>
          <tr style={{ textAlign: "center" }}>
            <td>Left Eye</td>
            <td style={{ borderLeft: "solid 1px #5F6B7C" }}>
              {each.le.v_dist === "---" ? "" : each.le.v_dist}
            </td>
            <td>{each.le.v_ph === "---" ? "" : each.le.v_ph}</td>
            <td>{each.le.v_near === "---" ? "" : each.le.v_near}</td>{" "}
            <td style={{ borderLeft: "solid 1px #5F6B7C" }}>
              {each.le.sph === "---" ? "" : this.renderPlusMinus(each.le.sph)}
            </td>
            <td>
              {each.le.cyl === "---" ? "" : this.renderPlusMinus(each.le.cyl)}
            </td>
            <td>
              {each.le.axis === "---" ? "" : this.renderAxis(each.le.axis)}
            </td>
            <td>
              {each.le.add === "---" ? "" : this.renderPlusMinus(each.le.add)}
            </td>
          </tr>
        </>
      );
    });
  };
  renderPlusMinus = (num) => {
    if (num === 0) {
      return num;
    }
    if (num > 0) {
      return `+${num.toFixed(2)}`;
    } else {
      return num.toFixed(2);
    }
  };
  renderAxis = (num) => {
    return `${num}°`;
  };
  /**Medicines and Advice */

  renderAdvice = () => {
    let adv = [];
    if (this.state.clinical.landing.todayVisit.vision.glassAdvice.length) {
      let tt = this.state.clinical.landing.todayVisit.vision.glassAdvice;
      if (tt.includes("Contact Lenses")) {
        _.remove(tt, (each) => each === "Contact Lenses");
        adv.push({ text: "Contact lenses prescribed." });
      }
      if (tt.length) {
        let gg = tt.join(" / ");
        gg += " glasses prescribed.";
        adv.push({ text: gg });
      }
    }
    if (!adv.length) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginRight: "10px",
          justifyContent: "flex-start",
        }}
      >
        <>{this.renderHorizontalText("ADVICE", true)}</>

        {adv.map((each) => {
          return (
            <div className="pres-vision__workup__tags">
              <Tag
                minimal
                multiline
                className="pres-font__small pres-pres-bg__none"
              >
                {`${each.text}`}
              </Tag>
              <Tag
                minimal
                multiline
                className="pres-font__small pres-pres-bg__none"
              >
                {each.durationText}
              </Tag>
            </div>
          );
        })}
      </div>
    );
  };

  /**Medicines and Advice */
  /** Follow Up & Doc */
  renderFUDoc = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>{this.renderAdvice()}</div> <div>{this.renderDoc()}</div>
      </div>
    );
  };
  renderFollowUp = () => {
    let fuObj = this.state.clinical.landing.todayVisit.followup[0];
    let fuString = "";
    if (fuObj.refer) {
      if (fuObj.when) {
        fuString = `Referred to ${fuObj.referTo} - ${fuObj.when}. `;
      } else {
        fuString = `Referred to ${fuObj.referTo}. `;
      }
      if (fuObj.referralNote) {
        fuString = fuString + " Note: " + fuObj.referralNote;
      }
    } else {
      if (fuObj.when) {
        fuString = `Follow up with your doctor - ${fuObj.when}.`;
      } else {
        fuString = "";
      }
    }
    let fuWith = this.state.clinical.landing.todayVisit.followupWith.map(
      (each) => {
        let eye = each.eye ? `${initials(each.eye)}: ` : "";
        let st = each.subtype === "Generic" ? "" : ` - ${each.subtype}`;
        return eye + each.type + st + " - " + each.when;
      }
    );
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          marginRight: "10px",
        }}
      >
        <>{this.renderHorizontalText("FOLLOW UP")}</>
        {fuString ? (
          <div>
            <Tag multiline minimal className="pres-max45 pres-font__x__small">
              {fuString}
            </Tag>
          </div>
        ) : (
          <div>
            <Tag multiline minimal className="pres-max45 pres-font__x__small">
              Regular check up recommended.
            </Tag>
          </div>
        )}

        <div>
          <Tag
            multiline
            minimal
            className="pres-max45 pres-pres-bg__none pres-font__x__small"
          >
            Contact the hospital for any issues, pain, discharge, drop of vision
            or discomfort.
          </Tag>
        </div>
        <div>
          {fuWith.length ? (
            <Tag minimal multiline className="pres-font__x__small">
              Follow Up with:
            </Tag>
          ) : null}
          {fuWith.map((each) => {
            return (
              <div className="pres-vision__workup__tags">
                <Tag
                  minimal
                  multiline
                  className="pres-font__x__small pres-pres-bg__none"
                >
                  {each}
                </Tag>
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  renderDoc = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
          marginLeft: "10px",
          textAlign: "right",
        }}
      >
        <>{this.renderHorizontalText("DOCTOR", true)}</>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "50px",
          }}
        >
          <div className="pres-font__small">
            <b>{this.state.clinical.resource.name}</b>
          </div>
          <div className="pres-font__small">
            <b>{this.state.clinical.resource.qualifications}</b>
          </div>
          <div className="pres-font__small">
            Registration: <b>{this.state.clinical.resource.mrNumber}</b>
          </div>
        </div>
      </div>
    );
  };

  /** Follow Up & Doc */
  renderVerticalText = (text, isProminent = true) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          textOrientation: "upright",
          writingMode: "vertical-rl",
          marginRight: "10px",
          fontSize: "xx-small",
          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  renderHorizontalText = (text, isProminent = false) => {
    return (
      <div
        style={{
          textAlign: "center",
          backgroundColor: "#E6E7E7",
          marginBottom: "10px",
          fontSize: "xx-small",
          letterSpacing: "1mm",

          border: `${isProminent ? "1px solid black" : ""}`,
        }}
      >
        {isProminent ? <b>{text}</b> : <>{text}</>}
      </div>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div className="pres-center_screen">
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isFailure) {
      return (
        <div className="pres-center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    return (
      <div className="pres-glass_rx__container">
        <style type="text/css" media="print">
          {" @page { size: A4 portrait !important; margin: 3mm !important;"}
        </style>{" "}
        <div className="pres-no__print">
          <Button
            icon="print"
            text="Print"
            onClick={() => {
              window.print();
            }}
            fill
          />{" "}
          <br />
          <br />
        </div>
        {this.renderHeader()}
        <hr />
        {this.renderVisionSection()} <hr />
        {this.renderFUDoc()}
      </div>
    );
  }
}

const GlassRx = withRouter(GlassRxLowerOrder);
export default GlassRx;
